import { useState } from 'react';
import { toast } from 'sonner';
import { Search } from 'lucide-react';
import api from '../../services/api';

const inputCls = 'w-full border border-slate-300 rounded px-2 py-1.5 text-sm bg-white text-slate-900 focus:outline-none focus:ring-2 focus:ring-slate-900/10';

// Per-page <head> settings: meta title/description, canonical URL, indexing.
export function PageSeoEditor({ page, onSaved }) {
  const [f, setF] = useState({
    meta_title: page.meta_title || '',
    meta_description: page.meta_description || '',
    canonical_url: page.canonical_url || '',
    noindex: !!page.noindex,
  });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF((v) => ({ ...v, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }));
  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/super-admin/website/pages/${page.id}`, f);
      toast.success('SEO settings saved');
      onSaved();
    } catch (e) { toast.error(typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : 'Save failed'); }
    setSaving(false);
  };
  return (
    <div className="mt-2 grid md:grid-cols-2 gap-3 bg-slate-50 border border-slate-200 rounded p-3" data-testid={`page-seo-${page.slug}`}>
      <label className="block">
        <span className="text-xs text-slate-600">Meta title <span className="text-slate-400">({f.meta_title.length}/60 recommended)</span></span>
        <input value={f.meta_title} onChange={set('meta_title')} placeholder={`${page.title} · VyomOS`} className={inputCls} data-testid={`page-seo-title-${page.slug}`} />
      </label>
      <label className="block">
        <span className="text-xs text-slate-600">Canonical URL</span>
        <input value={f.canonical_url} onChange={set('canonical_url')} placeholder={`https://vyomos.io/${page.slug === 'home' ? '' : page.slug}`} className={inputCls} data-testid={`page-seo-canonical-${page.slug}`} />
      </label>
      <label className="block md:col-span-2">
        <span className="text-xs text-slate-600">Meta description <span className="text-slate-400">({f.meta_description.length}/160 recommended)</span></span>
        <textarea rows={2} value={f.meta_description} onChange={set('meta_description')} className={inputCls} data-testid={`page-seo-desc-${page.slug}`} />
      </label>
      <label className="inline-flex items-center gap-2 text-sm">
        <input type="checkbox" checked={f.noindex} onChange={set('noindex')} data-testid={`page-seo-noindex-${page.slug}`} />
        Hide from search engines (noindex)
      </label>
      <div className="text-right">
        <button type="button" onClick={save} disabled={saving} className="text-xs px-3 py-1.5 rounded bg-slate-900 text-white disabled:opacity-50" data-testid={`page-seo-save-${page.slug}`}>
          {saving ? 'Saving…' : 'Save SEO'}
        </button>
      </div>
    </div>
  );
}

export const SeoToggle = ({ open, onClick, slug }) => (
  <button type="button" onClick={onClick} title="SEO / head settings" data-testid={`page-seo-toggle-${slug}`}
    className={`inline-flex items-center gap-1 px-2 py-1 text-xs rounded ${open ? 'bg-slate-900 text-white' : 'text-slate-600 border border-slate-200 hover:bg-slate-100'}`}>
    <Search className="w-3.5 h-3.5" /> SEO
  </button>
);
